import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import type { ClaseCompletaResultado } from '../../services/api/plazaService';

/**
 * Lo que de verdad pasó al dar la plaza: las clases en las que el cliente no
 * cupo y si se le dio una recuperación por cada una. Puede diferir de la vista
 * previa si alguien reservó entre el aviso y la confirmación.
 */

// `fecha` es la medianoche UTC del día de la clase: se lee en UTC para no
// desplazarla un día.
const fechaClase = (c: ClaseCompletaResultado) =>
    format(new Date(new Date(c.fecha).toISOString().slice(0, 10) + 'T12:00:00'), "EEEE d 'de' MMMM", { locale: es });

interface Props {
    clases?: ClaseCompletaResultado[];
    // Inicio de la primera clase real: la fecha desde la que se prorratea en caja.
    primeraClase?: string | null;
}

export const ResumenClasesCompletas = ({ clases, primeraClase }: Props) => {
    const inicio = primeraClase && new Date(primeraClase) > new Date()
        ? (
            <p className="rounded-md border border-blue-200 bg-blue-50 px-3 py-2 text-sm text-blue-900 text-left">
                Su primera clase es el <strong>{format(new Date(primeraClase), "EEEE d 'de' MMMM 'a las' HH:mm", { locale: es })}</strong>.
                El primer mes se cobra desde ese día.
            </p>
        )
        : null;

    if (!clases?.length) return inicio;
    const compensadas = clases.filter((c) => c.compensada).length;

    return (
        <div className="space-y-2">
            {inicio}
            <div className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900 text-left">
                <p className="font-medium">
                    {clases.length === 1
                        ? 'No entró en 1 clase porque estaba completa:'
                        : `No entró en ${clases.length} clases porque estaban completas:`}
                </p>
                <ul className="mt-1 list-disc pl-5">
                    {clases.map((c) => (
                        <li key={c.eventoId}>
                            {fechaClase(c)} a las {c.horaInicio}
                            {c.compensada === undefined ? '' : c.compensada ? ' — con recuperación' : ' — sin recuperación'}
                        </li>
                    ))}
                </ul>
                {compensadas > 0 && (
                    <p className="mt-1 text-xs">
                        Se {compensadas === 1 ? 'le ha dado 1 recuperación' : `le han dado ${compensadas} recuperaciones`}.
                    </p>
                )}
            </div>
        </div>
    );
};

export default ResumenClasesCompletas;
